import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_CZ.json';
import exercises from './PILATES_EXERCISES_CZ.json';
import recipes from './PILATES_RECIPES_CZ.json';

export const PILATES_DATA_CZ: ServiceData = {
  articles,
  exercises,
  recipes,
};
